export default "__VITE_ASSET__Dl8DQ89C__"